import React from "react";
import { motion } from "framer-motion";
import { Arrow } from "../components/Layout";

const team = [
  {
    initials: "MA",
    name: "Márta Alexy",
    role: "CIO",
    lead: "Agricultural engineer, habilitated researcher and associate professor specialising in Precision Livestock Farming.",
    body: "Her work connects animal production, biological context and digital technology. She works with livestock data, sensing, computer vision and machine learning with a strong emphasis on what can actually be validated and used under commercial conditions. In Birdwatcher, this perspective keeps the engineering tied to the biological and production system rather than treating the barn as a generic computer-vision scene.",
    focus: ["Precision Livestock Farming", "Animal production", "Applied AI", "Commercial field validation"],
  },
  {
    initials: "GT",
    name: "Gergő Tóth",
    role: "CEO",
    lead: "Computer scientist and applied AI researcher focused on mathematical modelling, statistical learning, computer vision and deployable data systems.",
    body: "His work spans experimental design, sampling, uncertainty analysis, model development, edge/cloud architecture and production deployment. A recurring focus is separating where system error actually comes from instead of treating one accuracy score as the whole problem. In Birdwatcher, that means connecting the statistical measurement problem to a system that can be installed, monitored, calibrated and operated in the field.",
    focus: ["Statistical learning", "Computer vision", "Mathematical modelling", "Research to deployment"],
  },
];

export default function TeamPage() {
  return (
    <div className="page page-team">
      <section className="page-hero page-section team-hero">
        <div>
          <p className="eyebrow">05 / Team</p>
          <h1>Agriculture and computation have to meet in the field.</h1>
        </div>
        <p className="page-hero-lead">Birdwatcher is one Agroadvisor project. The team combines livestock-domain knowledge with modelling, software, infrastructure and deployment.</p>
      </section>

      <section className="page-section team-grid team-page-grid">
        {team.map((member, index) => (
          <motion.article
            className="person-card"
            key={member.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="person-top">
              <div className="person-initials">{member.initials}</div>
              <div>
                <h2>{member.name}</h2>
                <p className="person-role">{member.role}</p>
              </div>
            </div>
            <p className="person-lead">{member.lead}</p>
            <p className="person-body">{member.body}</p>
            <div className="tag-list">
              {member.focus.map((item) => <span key={item}>{item}</span>)}
            </div>
          </motion.article>
        ))}
      </section>

      <section className="page-section company-scope">
        <div>
          <p className="eyebrow">Agroadvisor</p>
          <h2>Birdwatcher is not the whole story.</h2>
        </div>
        <div className="scope-grid">
          <article><span>01</span><strong>Data acquisition</strong><p>Designing how useful field data can actually be collected.</p></article>
          <article><span>02</span><strong>Applied AI</strong><p>Computer vision, statistical learning and problem-specific modelling.</p></article>
          <article><span>03</span><strong>Connected systems</strong><p>Edge, cloud, sensing, pipelines and operational software.</p></article>
          <article><span>04</span><strong>Validation</strong><p>Sampling, uncertainty, generalisation, failure modes and calibration.</p></article>
          <article><span>05</span><strong>Development</strong><p>From a difficult measurement problem to a deployed system.</p></article>
        </div>
      </section>

      <section className="page-section contact contact-page-card">
        <div>
          <p className="eyebrow">Private by default</p>
          <h2>Want to see Birdwatcher in context?</h2>
          <p>There is no public demo. We share live examples, technical detail and deployment discussions directly with prospective partners and customers.</p>
        </div>
        <div className="contact-actions">
          <a className="button button-primary button-light" href="mailto:info@agroadvisor.hu?subject=Birdwatcher%20private%20demo">Request a private demo <Arrow /></a>
          <a className="button button-outline-light" href="mailto:info@agroadvisor.hu?subject=Agroadvisor%20project%20quote">Request a project quote</a>
        </div>
        <div className="contact-meta">
          <a href="mailto:info@agroadvisor.hu">info@agroadvisor.hu</a>
          <a href="tel:+36301634341">+36 30 163 4341</a>
        </div>
      </section>
    </div>
  );
}
